import MobileSupportedModalView from './mobile_supported_modal_view';
import SitterCardQuickViewDescriptionView from './sitter_card_quick_view_description_view';

export default MobileSupportedModalView.extend({
  events: {
    'click .js-previous-sitter': 'previousSitter',
    'click .js-next-sitter': 'nextSitter',
  },

  initialize(options) {
    MobileSupportedModalView.prototype.initialize.call(this, options);

    this.rank = options.rank;
    this.service_type = options.service_type;

    this.descriptionView = null;

    this.contentLoaded = false;

    // Load the content on show
    this.$modal.on('show.bs.modal', _.bind(this.loadContent, this));

    // Listen for events to trigger quick view show
    Rover.pubSub.on(
      `sitterCard:show:${this.model.get('service_pk')}`,
      _.bind(this.showModal, this)
    );
  },

  contentUrl() {
    return `/services/${this.model.get('service_pk')}/quick_view_content/`;
  },

  loadContent() {
    if (this.contentLoaded) {
      return;
    }

    const params = Rover.searchResultsQueue.getQueryParams();
    $.ajax({
      dataType: 'html',
      url: this.contentUrl(),
      data: $.param(params, true),
      traditional: true,
      success: _.bind(this.onContentLoaded, this),
    });
  },

  onContentLoaded(html) {
    // Replace the content html
    this.$('.modal-content').html(html);
    this.contentLoaded = true;

    // Call the super class
    MobileSupportedModalView.prototype.onContentLoaded.call(this);

    // Initialize images and popovers
    this.initializePopovers();
    this.loadImages();

    this.descriptionView = new SitterCardQuickViewDescriptionView({
      el: this.$('.js-sitter-quick-view-desc'),
      quickView: this,
    });

    // Listen for keypresses (left / right)
    this.$modal.on('keyup', _.bind(this.onKeyUp, this));

    // Hide chevrons when there is only one result
    if (this.model.collection.length > 1) {
      this.$('.modal-control').removeClass('hidden');
    } else {
      this.$('.modal-control').addClass('hidden');
    }

    // Hide image gallery chevrons when there is only one row
    if (this.$('.js-photos-carousel .item').length <= 2) {
      this.$('.js-carousel-control').hide();
    }

    this.addSwipeToCarousel(this.$('.js-photos-carousel'));

    // Bind dataLayer events
    this.$el
      .find('.js-quick-view-sitter-link')
      .click(_.bind(this.fireEvent, this, 'search-quickview-sitter-name'));
    this.$el
      .find('.js-carousel-control')
      .click(_.bind(this.fireEvent, this, 'search-quickview-photos'));
    this.$el
      .find('.js-quick-view-contact-link')
      .click(_.bind(this.fireEvent, this, 'search-quickview-contact-sitter'));
    this.$el
      .find('.js-quick-view-full-profile-link')
      .click(_.bind(this.fireEvent, this, 'search-quickview-full-profile'));
    this.$el
      .find('.js-quick-view-review-count')
      .click(_.bind(this.fireEvent, this, 'search-quickview-reviews'));
    this.$el
      .find('.js-favorite-button')
      .click(_.bind(this.fireEvent, this, 'search-quickview-save-sitter'));
  },

  destroyView() {
    if (this.descriptionView) {
      this.descriptionView.destroyView();
    }
    this.undelegateEvents();
    this.remove();
  },

  initializePopovers() {
    Rover.stickyPopover(this.$('.js-badge-popover'), {
      placement: 'bottom',
      container: this.$el,
      tracking: true,
    });
  },

  loadImages() {
    let $carousel = this.$('.js-photos-carousel'),
      $target = $carousel.find('div.item.active'),
      event = $.Event('slide.bs.carousel', {
        relatedTarget: $target,
      });

    // Once we've loaded an image, set the height for all of the yet
    // to load images.
    $carousel.find('div.item').on('loaded', _.bind(this.setCarouselLoadingHeight, this));

    // Trigger the fake slide event
    $carousel.trigger(event);
  },

  setCarouselLoadingHeight() {
    const $carousel = this.$('.js-photos-carousel');

    // Set the heights for the yet to load images
    $carousel.find('[data-src]').height($carousel.height());

    // Remove explicit height for loaded images
    $carousel.find('img:not([data-src])').height('auto');
  },

  addSwipeToCarousel($carousel) {
    $carousel.swiperight(function() {
      $(this).carousel('prev');
    });
    $carousel.swipeleft(function() {
      $(this).carousel('next');
    });
  },

  onKeyUp(e) {
    if (e.keyCode === 37) {
      // Left key press
      this.previousSitter();
    } else if (e.keyCode === 39) {
      // Right key press
      this.nextSitter();
    }
  },

  nextSitter() {
    Rover.pubSub.trigger('quickView:next', this);
  },

  previousSitter() {
    Rover.pubSub.trigger('quickView:previous', this);
  },

  fireEvent(eventName) {
    dataLayer.push({
      event: eventName,
      providerId: this.model.get('person_opk'),
    });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/sitter_card_quick_view.js